const Datalist = ({ children }) => (
  <ul className="list-unstyled">{children}</ul>
);

export default Datalist;
